import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export default function useDivisionFormTemplates({
  divisionId,
  includeArchived = false,
} = {}) {
  const formTemplates = useSelector((state) => state.forms.templates);
  const selectedDivisions = useSelector((state) => state.settings.selectedDivisions);

  const divTemplates = useMemo(() => (
    Object.values(formTemplates).filter((template) => (
      template.notDeleted
      && (includeArchived || template.active)
      && (
        (divisionId && (
          template.divisionId === divisionId
          || template.divisionIds?.includes(divisionId)
        ))
        || (!divisionId && (
          selectedDivisions.has(template.divisionId)
          || template.divisionIds?.some((divId) => selectedDivisions.has(divId))
        ))
      )
    ))
  ), [formTemplates, selectedDivisions, divisionId, includeArchived]);
  return divTemplates;
}
